import ajax from '../Common/API/ajax'
// import storage from 'Common/API/Storage'
// import device from 'Common/API/Device'
import util from '../Common/API/util'
// import wx from 'Common/API/WX'
// import googleMap from 'Common/API/GoogleMap'
import _aspect from '../Common/API/iView'
const noParams={}
export default {
    util,
    admin: {
        signIn(params) {
            return ajax.post('/admin/signIn', params)
        },
        sync() {
            return ajax.get('/admin/sync')
        },
        signOut() {
            return ajax.delete('/admin/signOut')
        },
    },

    player: {
      searchPage (condition, page) {
        return ajax.post('/player/searchPage', {condition, page})
      },
    },

    challenge: {
      searchPage (condition, page) {
        return ajax.post('/challenge/searchPage', {condition, page})
      },
      create(params) {
        return ajax.post('/challenge/create', params)
      },
      update(params) {
        return ajax.post('/challenge/update', params)
      },
      delete(id) {
        return ajax.delete('/challenge/' + id)
      },
    },

    player_challenge: {
      searchPage (condition, page) {
        return ajax.post('/player_challenge/searchPage', {condition, page})
      },
    },

    gift: {
      searchPage (condition, page) {
        return ajax.post('/gift/searchPage', {condition, page})
      },
      create(params) {
        return ajax.post('/gift/create', params)
      },
      update(params) {
        return ajax.post('/gift/update', params)
      },
      delete(id) {
        return ajax.delete('/gift/' + id)
      },
    },

    shop: {
      searchPage (condition, page) {
        return ajax.post('/shop/searchPage', {condition, page})
      },
      create(params) {
        return ajax.post('/shop/create', params)
      },
      update(params) {
        return ajax.post('/shop/update', params)
      },
      delete(id) {
        return ajax.delete('/shop/' + id)
      },
    },

    redeem: {
      searchPage (condition, page) {
        return ajax.post('/redeem/searchPage', {condition, page})
      },
    },

    delivery: {
      searchPage (condition, page) {
        return ajax.post('/delivery/searchPage', {condition, page})
      },
    },
  

    file: {
        imageUpload() {
            return ajax.post('/file/imageUpload')
        }
    },

}



// WEBPACK FOOTER //
// ./src/API/index.js